import styled from 'styled-components'
import Link from 'next/link'

export const ProductTileWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  a {
    @media (max-width: 900px) {
      white-space: normal;
    }

    .product-tile__image {
      @media (max-width: 1400px) {
        height: 15vw;
      }

      @media (max-width: 768px) {
        width: 100%;
        height: 20vw;
        min-height: 110px;
      }
    }
  }
`

export const ListNumber = styled.span`
  background: var(--brand-secondary);
  position: absolute;
  top: 8px;
  left: 8px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  text-align: center;
  color: white;
  z-index: 2;
  line-height: 35px;
  border-radius: 50%;
  font-weight: var(--font-bold);

  @media (max-width: 900px) {
    width: 25px;
    height: 25px;
    font-size: 12px;
  }
`

export const Wrapper = styled(Link)`
  text-decoration: none;
  color: var(--brand-secondary);
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover > div:first-child {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.12);
  }
`

export const ProductImage = styled.div`
  position: relative;
  background-position: center center;
  background-size: cover;
  border-radius: 12px;
  width: 100%;
  height: 224px;
  margin-bottom: 18px;
  transition: 0.1s ease-in-out;

  @media (max-width: 900px) {
    width: 100%;
    height: 200px;
  }
`

export const Title = styled.h3`
  font-size: 16px;
  line-height: 21px;
  margin-bottom: 8px;
  font-weight: var(--font-medium);
  display: -webkit-box;
  width: 100%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const Main = styled.div`
  margin-bottom: 10px;
`
